import { Box, IconButton, Typography } from '@mui/material'
import React from 'react'
import Stack from '@mui/material/Stack'
import Twitter from '@mui/icons-material/Twitter';
import GitHub from '@mui/icons-material/GitHub';

export const Footer = () => {
  return (
    <Box sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        py: 5,
        px:0,
        mt: 3
    }}>
        
        <Typography>
            Made with 💖 by Dave 
        </Typography>
        
        <Stack direction="row">
            <IconButton 
              sx={{m:3, '&:hover':{color:"#00acee"}}}
              href="https://twitter.com/HieDave_"
              >
                <Twitter sx={{fontSize:30}}/>
            </IconButton>
            <IconButton 
              sx={{m:3, '&:hover':{color:"#171515"}}}
              href="https://github.com/HieDave"
              >
                <GitHub sx={{fontSize:30}}/>
            </IconButton>
        </Stack>
    </Box>
  )
}
